import loadable from '@loadable/component'

export default {
  '/login': loadable(() => import('./Login')),
  '/:any/login': loadable(() => import('./Login')),
  '/:type/': loadable(() => import('./Home')),
  '/': loadable(() => import('./Home'))
}
